import React from "react";
import {IProduct} from 'data/interfaces/products';
import {IOrder, IOrderOptions} from 'data/interfaces/orders';
import {ITransaction} from 'data/interfaces/transactions';
import {IUser} from 'data/redux/reducers/authenticationReducer';
import FirstStage from "./components/firstStage/FirstStage";
import PreparedAdStructure from '../commons/preparedAdStructure';
import SaleDetails from './components/saleDetails';
import PurchaseDetails from './components/purchaseDetails';
import {voucherLogo} from 'gui/components/listPage/components/ad/components/voucherImageSquare';
import {generateVoucherTitle} from 'gui/components/listPage/components/ad/components/adVoucher';
import TopDetails
  from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure/components/purchaseForm/components/topDetails';
import AdLeaveDate from 'gui/components/listPage/components/ad/components/adLeaveDate';

export interface IAdVoucher {
  product: IProduct;
  order: IOrder;
  transaction?: ITransaction;
  user: IUser;
  signedIn?: boolean;
  isProductOwner: boolean;
  isOrderOwner: boolean;
  beginOrder?: (product: IProduct, options: IOrderOptions) => Promise<void>;

}

export const AdVoucherTopDetails = props => <TopDetails title={generateVoucherTitle(props)}
                                                        logoSrc={voucherLogo(props.product)}>
  <AdLeaveDate
    label="תאריך סיום תוקף"
    endDate={props.product.voucherDetails.expiration}
  />
</TopDetails>;

const AdVoucher = (props: IAdVoucher) => {
  return (<PreparedAdStructure
    {...props}
    firstStageComponent={FirstStage}
    title={generateVoucherTitle(props)}
    originalPrice={props.product.voucherDetails.voucherBalance}
    saleDetails={<SaleDetails product={props.product} order={props.order}/>}
    purchaseDetails={<PurchaseDetails product={props.product}/>}
    aboveConclusionCardComponent={
      <AdVoucherTopDetails {...props}/>
    }
  />);
};

AdVoucher.defaultProps = {
  product: {},
  isProductOwner: false,
  isOrderOwner: false,
};

export default AdVoucher;
